import { log } from 'log';
import { withProps } from 'recompose';
import { useUserSelector } from '@core/js/store/hooks';
import { compose, prop } from 'ramda';
import { useGameConfig } from '@core/js/components/common/Game';
import { withTranslations } from '@core/js/components/hocs/withTranslations';
import withGameDescription from '@core/js/components/popups/GamesInfoPopup/components/GameInfo/withGameDescription';

import { Title, GameInfoBare } from '@core/js/components/popups/GamesInfoPopup/components/GameInfo/GameInfo';

export { Title, GameInfoBare };

export const GameInfo = compose(
    withTranslations,
    withProps(({ data: { code, queryString } }) => {
        const isLoggedIn = useUserSelector(prop('isLoggedIn'));
        const { gameCode, demoModeSupport, images = {}, ...game } = useGameConfig(code);

        if (!gameCode) {
            log('warn', `Game with code '${code}' can not be found`);
            return;
        }

        return {
            ...game,
            queryString,
            code: gameCode,
            image: !isLoggedIn && images.guest || images.base,
            showFavorite: isLoggedIn,
            gamesYouMightLike: [],
            demoModeSupport: !(demoModeSupport === 'unavailable' || demoModeSupport === 'guest' && isLoggedIn)
        };
    }),
    withProps(withGameDescription(145))
)(GameInfoBare);
